import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
    isSidebarOpen: boolean;
    isSidebarCollapsed: boolean;
    theme: 'light' | 'dark';
}

const initialState: UiState = {
    isSidebarOpen: true,
    isSidebarCollapsed: false,
    theme: 'light',
};

const uiSlice = createSlice({
    name: 'ui',
    initialState,
    reducers: {
        toggleSidebar: (state) => {
            state.isSidebarOpen = !state.isSidebarOpen;
        },
        toggleSidebarCollapsed: (state) => {
            state.isSidebarCollapsed = !state.isSidebarCollapsed;
        },
        setSidebarOpen: (state, action: PayloadAction<boolean>) => {
            state.isSidebarOpen = action.payload;
        },
        setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
            state.theme = action.payload;
        },
    },
});

export const { toggleSidebar, toggleSidebarCollapsed, setSidebarOpen, setTheme } = uiSlice.actions;
export default uiSlice.reducer;
